import { MessageID } from "../i18n/types";
import { OrderStatus } from "../generated/graphql";

// icons
import paidIconImg from "../assets/order-status-icon/paid.svg";
import shippedIconImg from "../assets/order-status-icon/shipped.svg";
import orderSentIconImg from "../assets/order-status-icon/pending.svg";
import refundingIconImg from "../assets/order-status-icon/refunding.svg";
import refundedIconImg from "../assets/order-status-icon/refunded.svg";
import completedIconImg from "../assets/order-status-icon/completed.svg";
import cancelledIconImg from "../assets/order-status-icon/cancelled.svg";
import processingIconImg from "../assets/order-status-icon/processing.svg";
import returnRequestIconImg from "../assets/order-status-icon/return-request.svg";
import returnHandlingIconImg from "../assets/order-status-icon/return-handling.svg";
import returnRejectedIconImg from "../assets/order-status-icon/return-rejected.svg";
import receiptReceivedIconImg from "../assets/order-status-icon/receipt-received.svg";
import receiptRejectedImg from "../assets/order-status-icon/receipt-rejected.svg";
import returnedImg from "../assets/order-status-icon/returned.svg";
import outstandingPaymentImg from "../assets/order-status-icon/outstanding-payment.svg";
import paymentRejectedImg from "../assets/order-status-icon/payment-rejected.svg";

export function parseOrderStatus(
  status: string | undefined
): OrderStatus | null {
  if (status === undefined) {
    return null;
  }
  for (const value of Object.values(OrderStatus)) {
    if (value === status) {
      return value;
    }
  }
  return null;
}

export const orderStatusIconMap: { [key in OrderStatus]: string } = {
  [OrderStatus.Paid]: paidIconImg,
  [OrderStatus.Shipped]: shippedIconImg,
  [OrderStatus.OrderSent]: orderSentIconImg,
  [OrderStatus.Refunding]: refundingIconImg,
  [OrderStatus.Refunded]: refundedIconImg,
  [OrderStatus.Completed]: completedIconImg,
  [OrderStatus.Cancelled]: cancelledIconImg,
  [OrderStatus.Processing]: processingIconImg,
  [OrderStatus.ReturnRequest]: returnRequestIconImg,
  [OrderStatus.ReturnHandling]: returnHandlingIconImg,
  [OrderStatus.ReturnRejected]: returnRejectedIconImg,
  [OrderStatus.ReceiptReceived]: receiptReceivedIconImg,
  [OrderStatus.ReceiptRejected]: receiptRejectedImg,
  [OrderStatus.Returned]: returnedImg,
  [OrderStatus.OutstandingPayment]: outstandingPaymentImg,
  [OrderStatus.PaymentRejected]: paymentRejectedImg,
};

export const orderStatusDisplayNameIdMap: {
  [key in OrderStatus]: MessageID;
} = {
  [OrderStatus.Paid]: "view.orderStatus.paid",
  [OrderStatus.Shipped]: "view.orderStatus.shipped",
  [OrderStatus.OrderSent]: "view.orderStatus.orderSent",
  [OrderStatus.Refunding]: "view.orderStatus.refunding",
  [OrderStatus.Refunded]: "view.orderStatus.redunded",
  [OrderStatus.Completed]: "view.orderStatus.completed",
  [OrderStatus.Cancelled]: "view.orderStatus.cancelled",
  [OrderStatus.Processing]: "view.orderStatus.processing",
  [OrderStatus.ReturnRequest]: "view.orderStatus.returnRequest",
  [OrderStatus.ReturnHandling]: "view.orderStatus.returnHandling",
  [OrderStatus.ReturnRejected]: "view.orderStatus.returnRejected",
  [OrderStatus.ReceiptReceived]: "view.orderStatus.receiptReceived",
  [OrderStatus.ReceiptRejected]: "view.orderStatus.receiptRejected",
  [OrderStatus.Returned]: "view.orderStatus.returned",
  [OrderStatus.OutstandingPayment]: "view.orderStatus.outstandingPayment",
  [OrderStatus.PaymentRejected]: "view.orderStatus.paymentRejected",
};
